import SidebarRouterButton from '@/hoc/SidebarMenu/bones/SidebarRouterButton'
import type { MenuLinkView } from '../types'
import { StyledMenuEntryLink } from '../styled-components'

interface MenuLinkProps {
  link: MenuLinkView
  expanded: boolean
  fill: boolean
}

const MenuLink = ({ link, expanded, fill }: MenuLinkProps) => (
  <StyledMenuEntryLink
    to={link.to}
    id={link.id}
    aria-label={link.label}
    data-menu-slot
    $fill={fill}
    onMouseEnter={link.onMouseEnter}
  >
    <SidebarRouterButton text={link.label} icon={link.icon} floating expanded={expanded} />
  </StyledMenuEntryLink>
)

export default MenuLink
